var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46852 12.4143C5.14507 12.1556 4.67311 12.208 4.41435 12.5315C4.15559 12.8549 4.20803 13.3269 4.53148 13.5857L5.46852 12.4143ZM8.52642 15.8211L8.0579 16.4068H8.0579L8.52642 15.8211ZM11.2624 15.5973L10.7049 15.0956L11.2624 15.5973ZM19.5575 7.50172C19.8346 7.19384 19.8096 6.71962 19.5017 6.44253C19.1938 6.16544 18.7196 6.19039 18.4425 6.49828L19.5575 7.50172ZM4.53148 13.5857L8.0579 16.4068L8.99494 15.2355L5.46852 12.4143L4.53148 13.5857ZM11.8199 16.0991L19.5575 7.50172L18.4425 6.49828L10.7049 15.0956L11.8199 16.0991ZM8.0579 16.4068C9.19546 17.3168 10.8453 17.1819 11.8199 16.0991L10.7049 15.0956C10.262 15.5878 9.51202 15.6491 8.99494 15.2355L8.0579 16.4068Z",
    fill: "#26B0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedCheck);
export default __webpack_public_path__ + "static/media/selectedCheck.97aca39223292b5692a364399a083cca.svg";
export { ForwardRef as ReactComponent };